import { jsonldTwitter } from './JsonldStore';

export const updateJsonldTwitter = (value) => jsonldTwitter.update((oldValue) => value);
